import React, { useState, useEffect } from "react";
import logo from "../../assets/logos/TSV-Logo.webp";
import shape from "../../assets/images/navbar/navShape.png";
import closeIcon from "../../assets/images/navbar/navCloseBtn.png";
import { useNavigate } from "react-router-dom";

const NewMainNav = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { navItem: "News", navLink: "/news" },
    { navItem: "Procure Funds", navLink: "/procure-funds" },
    // { navItem: "Contact", navLink: "/contact" },
  ];

  const sidebarNavItems = [
    { navItem: "Portfolio", navLink: "/portfolio" },
    { navItem: "Procure Funds", navLink: "/procure-funds" },
    { navItem: "About", navLink: "/about" },
    { navItem: "News", navLink: "/news" },
    { navItem: "Contact", navLink: "/contact" },
  ];

  // Content for the three sections on larger screens
  const sectionContent = [
    {
      title: "Portfolio",
      description:
        "Explore our innovative projects and successful ventures that showcase our expertise and commitment to excellence.",
      link: "/portfolio",
    },
    {
      title: "News",
      description:
        "Stay updated with the latest developments, insights, and announcements from our dynamic journey.",
      link: "/news",
    },
    {
      title: "About Us",
      description:
        "Learn about our mission, values, and the passionate team driving innovation and success forward.",
      link: "/about",
    },
  ];

  // Scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrolled]);

  // Smooth scroll to News section
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const navbarHeight = 120; // adjust based on your actual nav height
      const sectionTop = section.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: sectionTop, behavior: "smooth" });
    }
  };

  const handleNavClick = (item) => {
    if (item.navItem === "News") {
      if (window.location.pathname !== "/") {
        navigate("/");
        // Wait for home page to load before scrolling
        setTimeout(() => scrollToSection("news"), 300);
      } else {
        scrollToSection("news");
      }
    } else {
      navigate(item.navLink);
    }
  };

  const handleSectionClick = (link) => {
    navigate(link);
    setIsOpen(false);
  };

  const newsCards = [
    {
      heading: "Complete Offerings",
      title: "Financial Consulting Insights That Drive Growth",
      description: "We Specialize In Finance And Business Consulting.",
    },
    {
      heading: "Complete Offerings",
      title: "Why Financial Consulting Matters More Than Ever",
      description: "We Specialize In Finance And Business Consulting.",
    },
    {
      heading: "Complete Offerings",
      title: "Financial Consulting Industry on the Rise",
      description:
        "Our Financial Consulting Services Include Strategy And Optimization.",
    },
  ];

  return (
    <nav
      className={`w-full bg-white shadow-md fixed top-0 md:top-10 left-0 z-[9999] transition-all duration-300 ${
        scrolled ? "md:top-0" : ""
      }`}
    >
      <div className="px-4 sm:px-6 lg:px-12">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div
            className="flex items-center cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src={logo}
              alt="Techspear Logo"
              className="h-14 w-auto transition-transform duration-300 hover:scale-105"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <div className="flex gap-6">
              {navItems.map((item, index) => (
                <div
                  key={item.navItem}
                  className="group cursor-pointer"
                  onClick={() => handleNavClick(item)}
                >
                  <div
                    className="relative py-1 text-primaryBgColor hover:text-primaryBtnHoverColor font-sans font-medium tracking-wide transition-all duration-300"
                    style={{ transitionDelay: `${index * 50}ms` }}
                  >
                    {item.navItem}
                    <span className="absolute left-0 bottom-0 w-0 h-[2.3px] bg-primaryBtnColor transition-all duration-300 group-hover:w-full"></span>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Menu Button */}
            <button
              onClick={() => setIsOpen(true)}
              aria-label="Open Menu"
              className="flex items-center transition-all duration-300 active:scale-95 hover:scale-110 hover:rotate-6"
            >
              <img
                src={shape}
                alt="Shape"
                className="h-8 w-auto drop-shadow-lg hover:drop-shadow-2xl transition-all duration-300"
              />
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(true)}
              aria-label="Open Menu"
              className="flex items-center transition-transform duration-300 active:scale-95"
            >
              <img src={shape} alt="Shape" className="h-8 w-auto" />
            </button>
          </div>
        </div>
      </div>

      {/* Sidebar */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex animate-fadeIn">
          {/* Left dark section with golden lines and content */}
          <div className="relative w-2/3 md:w-3/4 bg-[#00110b] animate-slideInLeft">
            {/* Golden vertical lines */}
            <div className="absolute top-0 left-1/3 w-px h-full bg-yellow-500 opacity-60 animate-pulse"></div>
            <div
              className="absolute top-0 left-2/3 w-px h-full bg-yellow-500 opacity-60 animate-pulse"
              style={{ animationDelay: "0.5s" }}
            ></div>

            {/* Content sections for larger screens */}
            <div className="hidden md:flex h-full tracking-wide font-sans">
              {/* Section 1: Portfolio */}
              <div
                className="w-1/3 p-8 flex flex-col justify-center cursor-pointer group"
                onClick={() => handleSectionClick(sectionContent[0].link)}
              >
                <div className="text-white transform transition-all duration-500">
                  <h3 className="font-mokoto text-2xl font-bold text-primaryBtnHoverColor mb-6 group-hover:text-[#3a937b] transition-colors duration-300">
                    {sectionContent[0].title}
                  </h3>

                  {/* Portfolio Stats */}
                  <div className="mb-6 opacity-0 animate-fadeIn delay-300">
                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div className="text-center">
                        <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                          25+
                        </div>
                        <div className="text-xs text-gray-400">Projects</div>
                      </div>
                      <div className="text-center">
                        <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                          $10M+
                        </div>
                        <div className="text-xs text-gray-400">
                          Funds Raised
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Project Categories */}
                  <div className="mb-6 opacity-0 animate-fadeIn delay-400">
                    <h4 className="text-primaryBtnHoverColor font-semibold text-sm mb-3">
                      Featured Categories
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {[
                        "FinTech",
                        "AI Startups",
                        "E-commerce",
                        "SaaS",
                        "Blockchain",
                        "Healthcare",
                      ].map((category, index) => (
                        <span
                          key={category}
                          className="glass-morphism px-3 py-1 rounded-full text-xs text-white border border-white/20 hover:border-primaryBtnHoverColor/60 transition-all duration-300 hover:scale-105"
                          style={{ animationDelay: `${500 + index * 100}ms` }}
                        >
                          {category}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Featured Project Preview */}
                  <div className="mb-6 opacity-0 animate-fadeIn delay-600">
                    <div className="glass-morphism p-4 rounded-lg border border-white/20 hover:border-primaryBtnHoverColor/60 transition-all duration-300">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-primaryBtnHoverColor text-xs font-semibold">
                          Featured
                        </span>
                        <span className="text-green-400 text-xs">✓ Live</span>
                      </div>
                      <h4 className="text-white font-semibold text-sm mb-1">
                        WealthTech Platform
                      </h4>
                      <p className="text-gray-300 text-xs">
                        AI-powered investment platform with 300% YoY growth
                      </p>
                    </div>
                  </div>

                  {/* Success Metrics */}
                  <div className="opacity-0 animate-fadeIn delay-700">
                    <div className="flex justify-between text-center">
                      <div>
                        <div className="text-lg font-bold text-white">15</div>
                        <div className="text-xs text-gray-400">Exits</div>
                      </div>
                      <div>
                        <div className="text-lg font-bold text-white">3.5x</div>
                        <div className="text-xs text-gray-400">Avg. ROI</div>
                      </div>
                      <div>
                        <div className="text-lg font-bold text-white">
                          18 mos
                        </div>
                        <div className="text-xs text-gray-400">Avg. Hold</div>
                      </div>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-6 opacity-0 animate-fadeIn delay-800">
                    <div className="text-primaryBtnHoverColor text-sm font-semibold group-hover:translate-x-2 transition-transform duration-300 flex items-center">
                      Explore Our Portfolio
                      <span className="ml-2 group-hover:rotate-90 transition-transform duration-300">
                        →
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 2: News */}
              <div className="w-1/3 p-8 flex flex-col justify-center cursor-pointer group border-l border-r border-yellow-500 border-opacity-20">
                <div className="text-white transform transition-all duration-500">
                  <h3 className="font-mokoto text-2xl font-bold text-primaryBtnHoverColor mb-6 group-hover:text-[#3a937b] transition-colors duration-300">
                    {sectionContent[1].title}
                  </h3>
                  <p className="text-gray-300 text-sm leading-relaxed mb-6 opacity-0 animate-fadeIn delay-400">
                    {sectionContent[1].description}
                  </p>

                  {/* News Cards */}
                  <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
                    {newsCards.map((card, index) => (
                      <div
                        key={index}
                        className="glass-morphism p-4 rounded-lg cursor-pointer transform transition-all duration-300 border border-white/20 hover:border-primaryBtnHoverColor/60 backdrop-blur-sm"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent triggering the parent click
                          navigate("/news");
                          setIsOpen(false);
                        }}
                      >
                        <div className="mb-2">
                          <span className="glass-badge text-xs font-semibold px-2 py-1 rounded bg-white/20 text-white backdrop-blur-sm border border-white/30">
                            {card.heading}
                          </span>
                        </div>
                        <h4 className="text-white font-bold text-sm mb-2">
                          {card.title}
                        </h4>
                        <p className="text-gray-200 text-xs">
                          {card.description}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Section 3: About Us */}
              <div
                className="w-1/3 p-8 flex flex-col justify-center cursor-pointer group"
                onClick={() => handleSectionClick(sectionContent[2].link)}
              >
                <div className="text-white transform transition-all duration-500">
                  <h3 className="font-mokoto text-2xl font-bold text-primaryBtnHoverColor mb-6 group-hover:text-[#3a937b] transition-colors duration-300">
                    {sectionContent[2].title}
                  </h3>

                  {/* Main Description */}
                  <div className="mb-6 opacity-0 animate-fadeIn delay-500">
                    <p className="text-gray-300 text-sm leading-relaxed mb-4">
                      Our Story and About: Helping Businesses Thrive Through
                      Innovative Financial Solutions.
                    </p>
                    <p className="text-gray-300 text-sm leading-relaxed">
                      TechSpear Ventures Is A Leading Finance And Business
                      Consulting Firm Dedicated To Empowering Businesses With
                      Innovative Financial Solutions. Our Mission Is To Help
                      Clients Navigate The Complexities Of Finance, Optimize
                      Their Operations, And Achieve Sustainable Growth.
                    </p>
                  </div>

                  {/* Stats Grid */}
                  <div className="grid grid-cols-2 gap-4 mb-6 opacity-0 animate-fadeIn delay-600">
                    <div className="text-center">
                      <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                        2023
                      </div>
                      <div className="text-xs text-gray-400">Founded In</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                        Georgia
                      </div>
                      <div className="text-xs text-gray-400">Location</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                        100
                      </div>
                      <div className="text-xs text-gray-400">Happy Clients</div>
                    </div>
                    <div className="text-center">
                      <div className="text-2xl font-bold text-primaryBtnHoverColor mb-1">
                        50+
                      </div>
                      <div className="text-xs text-gray-400">Investors</div>
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="mt-6 opacity-0 animate-fadeIn delay-800">
                    <div className="text-primaryBtnHoverColor text-sm font-semibold group-hover:translate-x-2 transition-transform duration-300 flex items-center">
                      Explore More
                      <span className="ml-2 group-hover:rotate-90 transition-transform duration-300">
                        →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right white panel */}
          <div className="relative w-full sm:w-1/3 md:w-1/4 bg-white p-6 flex flex-col justify-between animate-slideInRight">
            {/* Header */}
            <div className="flex items-center justify-between absolute top-6 left-6 right-6 border-b border-gray-300 pb-6">
              <img
                src={logo}
                alt="Sidebar Left Icon"
                className="w-auto h-14 object-contain cursor-pointer"
                onClick={() => {
                  navigate("/");
                  setIsOpen(false);
                }}
              />

              <button
                onClick={() => setIsOpen(false)}
                aria-label="Close Menu"
                className="transition-transform duration-300 hover:rotate-90"
              >
                <img
                  src={closeIcon}
                  alt="Close Menu"
                  className="w-8 h-8 object-contain"
                />
              </button>
            </div>

            {/* Menu Items */}
            <div className="mt-24 space-y-6 tracking-wider font-mokoto">
              {sidebarNavItems.map((item, index) => (
                <div
                  key={item.navItem}
                  className="block text-xl md:text-2xl font-semibold text-primaryBgColor hover:text-primaryBtnColor transition-all duration-300 transform hover:translate-x-2 cursor-pointer"
                  onClick={() => {
                    handleNavClick(item);
                    setIsOpen(false);
                  }}
                  style={{
                    animation: `fadeInRight 0.5s ease forwards`,
                    animationDelay: `${index * 0.1}s`,
                    opacity: 0,
                  }}
                >
                  {item.navItem}
                </div>
              ))}
            </div>

            {/* Contact Info */}
            <div
              className="mt-8 border-t border-gray-300 pt-4 text-gray-700 text-sm animate-fadeIn"
              style={{ animationDelay: "0.6s" }}
            >
              <p className="font-bold text-lg md:text-xl">(+41) 889 55 687</p>
              <p className="text-gray-500 text-base md:text-lg">
                info@email.com
              </p>
            </div>
          </div>
        </div>
      )}

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideInLeft {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease forwards;
        }

        .animate-slideInLeft {
          animation: slideInLeft 0.4s ease forwards;
        }

        .animate-slideInRight {
          animation: slideInRight 0.4s ease forwards;
        }

        /* Delay utilities for staggered animations */
        .delay-300 {
          animation-delay: 0.3s;
        }

        .delay-400 {
          animation-delay: 0.4s;
        }

        .delay-500 {
          animation-delay: 0.5s;
        }

        .delay-600 {
          animation-delay: 0.6s;
        }

        .delay-700 {
          animation-delay: 0.7s;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideInLeft {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease forwards;
        }

        .animate-slideInLeft {
          animation: slideInLeft 0.4s ease forwards;
        }

        .animate-slideInRight {
          animation: slideInRight 0.4s ease forwards;
        }

        /* Glass morphism styles */
        .glass-morphism {
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.36),
            inset 0 1px 0 0 rgba(255, 255, 255, 0.1);
        }

        .glass-morphism:hover {
          background: rgba(255, 255, 255, 0.15);
          box-shadow: 0 12px 40px 0 rgba(0, 0, 0, 0.45),
            inset 0 1px 0 0 rgba(255, 255, 255, 0.2);
        }

        .glass-badge {
          background: rgba(255, 255, 255, 0.15);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid rgba(255, 255, 255, 0.3);
        }

        /* Delay utilities for staggered animations */
        .delay-300 {
          animation-delay: 0.3s;
        }

        .delay-400 {
          animation-delay: 0.4s;
        }

        .delay-500 {
          animation-delay: 0.5s;
        }

        .delay-600 {
          animation-delay: 0.6s;
        }

        .delay-700 {
          animation-delay: 0.7s;
        }
      `}</style>
    </nav>
  );
};

export default NewMainNav;